<script >
import { formatNumberLabel } from '@/features/charting-next/adapters/chartingAdapterUtils';
import { computed, ref } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  viewMode: {
    type: String,
    default: 'chart'
  },
  resolution: {
    type: String,
    default: 'M'
  },
  tickerSearch: {
    type: String,
    default: ''
  },
  sortOptions: {
    type: Array,
    default: () => []
  },
  sortValue: {
    type: String,
    default: 'original'
  },
  totalResults: {
    type: Number,
    default: 0
  },
  loadedResults: {
    type: Number,
    default: 0
  },
  isLoading: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const searchExpanded = ref(false);
  const submitSearch = () => emit('submit-ticker-search');
  const formattedLoadedResults = computed(() => formatNumberLabel(props.loadedResults, {
    maximumFractionDigits: 0
  }));
  const formattedTotalResults = computed(() => formatNumberLabel(props.totalResults || props.loadedResults, {
    maximumFractionDigits: 0
  }));
  return {
    emit,
    searchExpanded,
    submitSearch,
    formattedLoadedResults,
    formattedTotalResults
  };
};
export default __sfc_main;
</script>

<template>
    <header class="charting-mobile-toolbar">
        <div class="charting-mobile-toolbar__primary">
            <div class="charting-mobile-toolbar__view" aria-label="Vista del graficador">
                <button type="button" :class="{ 'is-active': viewMode === 'chart' }" @click="emit('change-view-mode', 'chart')"><i class="pi pi-chart-line"></i><span>Gráficos</span></button>
                <button type="button" :class="{ 'is-active': viewMode === 'table' }" @click="emit('change-view-mode', 'table')"><i class="pi pi-table"></i><span>Tabla</span></button>
            </div>

            <div v-if="viewMode === 'chart'" class="charting-mobile-toolbar__resolution" aria-label="Periodo">
                <button v-for="period in ['D', 'W', 'M']" :key="period" type="button" :class="{ 'is-active': resolution === period }" @click="emit('set-resolution', period)">{{ period }}</button>
            </div>

            <button type="button" class="charting-mobile-toolbar__icon" aria-label="Buscar ticker" :aria-expanded="searchExpanded ? 'true' : 'false'" @click="searchExpanded = !searchExpanded">
                <i :class="searchExpanded ? 'pi pi-times' : 'pi pi-search'"></i>
            </button>
        </div>

        <form v-if="searchExpanded" class="charting-mobile-toolbar__search" @submit.prevent="submitSearch">
            <InputText :model-value="tickerSearch" placeholder="Abrir ticker…" aria-label="Ticker" autofocus @update:model-value="emit('update:ticker-search', $event)" />
            <Button type="submit" icon="pi pi-arrow-right" aria-label="Abrir ticker" :disabled="!tickerSearch.trim()" />
        </form>

        <div class="charting-mobile-toolbar__secondary">
            <span>{{ isLoading ? 'Actualizando…' : `${formattedLoadedResults} de ${formattedTotalResults} valores` }}</span>
            <select :value="sortValue" aria-label="Ordenar resultados" :disabled="isLoading || !loadedResults" @change="emit('change-sort', $event.target.value)">
                <option v-for="option in sortOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
        </div>
    </header>
</template>

<style scoped>
.charting-mobile-toolbar { position: sticky; z-index: 30; top: var(--modern-shell-header-height, 62px); display: flex; flex-direction: column; gap: 0.45rem; border-bottom: 1px solid var(--charting-b-border-color); background: color-mix(in srgb, var(--charting-b-panel-bg-strong) 94%, transparent); padding: 0.55rem 0.7rem; backdrop-filter: blur(14px); }
.charting-mobile-toolbar__primary, .charting-mobile-toolbar__view, .charting-mobile-toolbar__resolution, .charting-mobile-toolbar__secondary { display: flex; align-items: center; }
.charting-mobile-toolbar__primary { gap: 0.5rem; }
.charting-mobile-toolbar__view, .charting-mobile-toolbar__resolution { border: 1px solid var(--charting-b-border-color); border-radius: 0.8rem; background: var(--charting-b-panel-bg); padding: 0.15rem; }
.charting-mobile-toolbar__view { min-width: 0; flex: 1 1 auto; }
.charting-mobile-toolbar__view button, .charting-mobile-toolbar__resolution button, .charting-mobile-toolbar__icon { min-height: 2rem; border: 0; border-radius: 0.62rem; background: transparent; color: var(--p-text-muted-color); font-weight: 800; cursor: pointer; }
.charting-mobile-toolbar__view button { display: inline-flex; min-width: 0; flex: 1 1 50%; align-items: center; justify-content: center; gap: 0.3rem; font-size: 0.72rem; }
.charting-mobile-toolbar__resolution button { min-width: 1.85rem; padding: 0.3rem; }
.charting-mobile-toolbar button.is-active { background: var(--charting-b-panel-bg-strong); color: var(--p-text-color); box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08); }
.charting-mobile-toolbar__icon { width: 2.35rem; min-width: 2.35rem; border: 1px solid var(--charting-b-border-color); background: var(--charting-b-panel-bg-strong); }
.charting-mobile-toolbar__search { display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 0.4rem; }
.charting-mobile-toolbar__secondary { justify-content: space-between; gap: 0.7rem; color: var(--p-text-muted-color); font-size: 0.7rem; font-weight: 800; }
.charting-mobile-toolbar__secondary select { min-width: 0; max-width: 58%; border: 1px solid var(--charting-b-border-color); border-radius: 0.65rem; background: var(--charting-b-panel-bg-strong); padding: 0.4rem 0.5rem; color: var(--p-text-color); font-size: 0.7rem; }
</style>
